import type { CtaType } from './LimitationModal.types';

export const mapCtaLabel: Record<CtaType, string> = {
  'enable-roadmap': 'Enable',
  'request-add-on': 'Request as add-on',
  'request-maker': 'Explore maker role',
};

export const REQUEST_ADD_ON_URL = 'https://hook.us1.make.com/tvx6mj1vmsg4ta7xf1s6pp3xip045c4l';
